export enum FeatureFlagConstant {
  CONFIG_TOBACCO = 'config_tobacco',
  CONFIG_GOOGLE_IMA = 'config_google_ima',
  CONFIG_PLAYER_RELOAD = 'config_player_reload',
  CONFIG_SPORTS = 'config_sports',
  FEATURE_ABR_CAPPING = 'feature_abr_capping',
  FEATURE_MIMETYPE_CHECK_ENABLED = 'feature_mimetype_check_enabled',
  CONFIG_PLAYER_OPTIONS_MOBILE = 'config_player_options_mobile',
  CONFIG_PLAYER_OPTIONS_DESKTOP = 'config_player_options_desktop',
  CONFIG_COMMERCE = 'config_commerce',
  CONFIG_REGISTRATION_POPUP = 'config_registration_popup',
  FEATURE_GATING = 'xmin_gating',
  CONFIG_PLAYER_ENTITLED_LANGUAGES = 'config_player_entitled_languages',
  CONFIG_PLAYER_LOGO = 'config_player_logo',
  MULTI_AUDIO = 'multi_audio_selection',
  CONFIG_PROFILES = 'config_profiles',
  CONFIG_NEW_SUBSCRIPTION_UI = 'config_new_sub_ui',
  DISABLE_UPNEXT_RECO_API = 'disable_upnext_reco_api',
  ENABLE_WATCH_HISTORY_VOD = 'enable_watch_history_vod'
}
